var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "animated fadeIn"
  }, [_c('b-row', {
    attrs: {
      "id": "home"
    }
  }, [(_vm.userAccessLevel != "agent") ? _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/dashboard"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-grid"
  }), _c('br'), _vm._v("Dashboard")])])], 1)], 1) : _vm._e(), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/interactions/live"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-bubbles"
  }), _c('br'), _vm._v("Interactions")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/videoCall"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-bubbles"
  }), _c('br'), _vm._v("Video Call")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/reports"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-people"
  }), _c('br'), _vm._v("Customers")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/broadcast"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-speech"
  }), _c('br'), _vm._v("Broadcast")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/graph"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-graph"
  }), _c('br'), _vm._v("Graph")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/chatflow"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-shuffle"
  }), _c('br'), _vm._v("Chat Flow (Beta)")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/manual"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-notebook"
  }), _c('br'), _vm._v("User Manual")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/profile"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "icon-user"
  }), _c('br'), _vm._v("Profile")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/crm/chatbot"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "fa fa-id-card-o"
  }), _c('br'), _vm._v("Task Reporting CRM")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/crm/chatbot"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "fa fa-car"
  }), _c('br'), _vm._v("Motor Accident CRM")])])], 1)], 1), _c('b-col', {
    attrs: {
      "md": "3"
    }
  }, [_c('b-link', {
    attrs: {
      "to": "/studio"
    }
  }, [_c('b-card', {
    staticClass: "text-center"
  }, [_c('h6', {
    staticClass: "card-title my-3"
  }, [_c('i', {
    staticClass: "fa fa-magic"
  }), _c('br'), _vm._v("NL Studio")])])], 1)], 1)], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-040eab0a","hasScoped":false}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home.vue
// module id = 862
// module chunks = 1